export const GRAPHCOLOURS = [
    {
        backgroundColor: 'rgba(163,188,0,0.6)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.5)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.4)'
    },
    {
        backgroundColor: 'rgba(207,239,0,0.3)'
    },
    {
        backgroundColor: 'rgba(163,188,0,0.9)'
    }
];
